<style scoped>
.excel-span {
  height: 24px;
  line-height: 24px;
  display: inline-block;
  padding: 1px 8px 1px 8px;
  border-radius: 4px;
  background-color: #f4f4f5;
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
}
</style>
<template>
  <div>
    <el-dialog :visible.sync="visible" :title="title" append-to-body="append-to-body" width="80%">
      <div :class="[tableData.length > 0 ? 'dialog-scroller' : '']" style="display: flex;flex-direction: column;">
        <!--上传-->
        <div>
          <input id="matterFileInput" ref="excel-upload-input" class="excel-upload-input" type="file" multiple
            accept=".xlsx, .xls" @change="handleClick" />
          <el-button :loading="loading" size="mini" type="primary" icon="el-icon-document-add" @click="exportModel">
            {{ $t('xiazaimuban') }}
          </el-button>
          <el-button :loading="loading" size="mini" type="default" icon="el-icon-plus" @click="handleUpload">
            {{ $t('piliangshangchuan') }}
          </el-button>
          <el-button :loading="exportLoading" size="mini" type="primary" icon="el-icon-upload2"
            @click="exportValidatedData">
            {{ $t('daochubaogao') }}
          </el-button>
        </div>
        <!--excel-->
        <div style="margin-top: 10px">
          <span v-for="(item, index) in excel" :key="index" class="excel-span" closable size="mini">
            <i class="el-icon-link" />
            <span>{{ item }}</span>
            <i style="margin-left: 5px" class="el-icon-close" @click="deleteExcel(item)" />
          </span>
        </div>
        <!--表格-->
        <div ref="table" style="flex: 1;margin-top: 10px;" v-loading="isLoading">
          <el-table stripe :max-height="tableHeight"
            :data="tableData.slice((pagination.currentPage - 1) * pagination.pageSize, pagination.currentPage * pagination.pageSize)"
            border size="mini"
            :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }">
            <el-table-column v-for="(item, index) in tableColumn" :key="index" :prop="item.prop"
              :show-overflow-tooltip="true" :label="item.label" :width="item.width" :sortable="item.sortable">
              <template slot-scope="scope">
                <span>{{ scope.row[item.prop] === '' ? '-' : scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div ref="pagination" style="padding-top: 10px;padding-bottom: 20px;">
          <el-pagination v-if="tableData.length > 0" style="display: flex;float: right;" background size="mini"
            :current-page="pagination.currentPage" :page-sizes="[10, 20, 100, 500]" :pagerCount="5"
            :page-size="pagination.pageSize" layout="total,sizes,prev,pager,next" :total="tableData.length"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" size="mini" @click="visible = false">{{ $t('quxiao') }}</el-button>
        <el-button :loading="loading" type="primary" size="mini" @click="importData">{{ $t('baocun') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      exportLoading: false,
      isLoading: false,
      loading: false,
      listLength: '',
      excel: [],
      tableHeight: 0,
      tableData: [],
      tableColumn: [
        {
          label: this.$t('daorubaogao'),
          prop: 'result',
          with: 125
        },
        {
          label: this.$t('wuliaobianma'),
          prop: 'code',
          sortable: true,
          with: 125
        },
        {
          label: this.$t('wuliaomingcheng'),
          prop: 'name',
          sortable: true,
          with: 130
        },
        {
          label: this.$t('jibenfenlei'),
          prop: 'typeText',
          sortable: true,
          with: 100
        },
        {
          label: this.$t('chanpinfenlei'),
          prop: 'value',
          sortable: true,
          with: 100
        },
        {
          label: this.$t('morendanwei'),
          prop: 'defaultUnit',
          sortable: true,
          with: 100
        },
        {
          label: this.$t('guige'),
          prop: 'spec',
          sortable: true
        },
        {
          label: this.$t('dangqianliaohao'),
          prop: 'no',
          sortable: true,
          with: 140
        },
        {
          label: this.$t('jiliangdanwei'),
          prop: 'unit',
          sortable: true,
          with: 100
        },
        {
          label: this.$t('baozhuangfangshi'),
          prop: 'pack',
          sortable: true,
          with: 100
        },
        {
          label: this.$t('maozhong(g)'),
          prop: 'grossWeight',
          sortable: true,
          with: 90
        },
        {
          label: this.$t('jingzhong(g)'),
          prop: 'netWeight',
          sortable: true,
          with: 90
        },
        {
          label: this.$t('shuikouzhong(g)'),
          prop: 'sprueWeight',
          sortable: true,
          with: 90
        },
        {
          label: this.$t('jianyanfenlei'),
          prop: 'checkoutType',
          sortable: true,
          with: 90
        },
        {
          label: this.$t('paichanyanse'),
          prop: 'planColor',
          sortable: true,
          with: 90
        },
        {
          label: this.$t('yanse'),
          prop: 'color',
          sortable: true,
          with: 90
        },
        {
          label: this.$t('sehao'),
          prop: 'colorNum',
          sortable: true,
          with: 90
        },
        {
          label: this.$t('sefen'),
          prop: 'colorPowder',
          sortable: true,
          with: 90
        },
        {
          label: this.$t('caizhi'),
          prop: 'ingredient',
          sortable: true,
          with: 90
        },
        {
          label: this.$t('tuhao'),
          prop: 'drawingNo',
          width: 90
        },
        {
          label: this.$t('miaoshu'),
          prop: 'describe'
        },
        {
          label: this.$t('shuikouyuntoubili'),
          prop: 'waterRatio'
        },
        {
          label: this.$t('hegelv'),
          prop: 'passRate'
        },
        {
          label: this.$t('erpwuliaobianma'),
          prop: 'erpMaterialCode',
          width: 100
        },
        {
          label: this.$t('shifouqiyong'),
          prop: 'enabledText',
          type: 'bool',
          iln18: ['shi', 'fou'],
          width: 80
        }
        // {
        //   label: '创建时间',
        //   prop: 'createTime'
        // },
        // {
        //   label: '修改时间',
        //   prop: 'updateTime'
        // }
      ],
      pagination: {
        currentPage: 1,
        pageSize: 10
      },
      visible: false,
      title: this.$t('daoru')
    };
  },
  watch: {
    show: {
      handler(n) {
        this.visible = n;
        if (n == true) {
          this.countTableHeight();
        }
        if (n == false) {
          this.currentPage = 1;
        }
      },
      immediate: false
    },
    visible: {
      handler(n) {
        if (!n) {
          this.$emit('update:show', false);
          this.tableData = [];
          this.excel = [];
          this.$refs['excel-upload-input'].value = null;
        }
      },
      immediate: false
    }
  },
  mounted() { },
  methods: {
    exportValidatedData() {
      if (this.listLength === 0 || !this.tableData.length) {
        this.$message.error(this.$t('meiyoukedaochudeshuju'));
        return;
      }
      this.exportLoading = true;
      const daorubaogao = this.$t('daorubaogao');
      const wuliaobianma = this.$t('wuliaobianma');
      const wuliaomingcheng = this.$t('wuliaomingcheng');
      const jibenfenlei = this.$t('jibenfenlei');
      const chanpinfenlei = this.$t('chanpinfenlei');
      const morendanwei = this.$t('morendanwei');
      const dangqianliaohao = this.$t('dangqianliaohao');
      const jiliangdanwei = this.$t('jiliangdanwei');
      const baozhuangfangshi = this.$t('baozhuangfangshi');
      const maozhong = this.$t('maozhong(g)');
      const jingzhong = this.$t('jingzhong(g)');
      const jianyanfenlei = this.$t('jianyanfenlei');
      const paichanyanse = this.$t('paichanyanse');
      const yanse = this.$t('yanse');
      const sehao = this.$t('sehao');
      const caizhi = this.$t('caizhi');
      const tuhao = this.$t('tuhao');
      const miaoshu = this.$t('miaoshu');
      const erpwuliaobianma = this.$t('erpwuliaobianma');
      const guige = this.$t('guige');
      const shifouqiyong = this.$t('shifouqiyong');
      const data = this.tableData.map(item => ({
        [daorubaogao]: item.result,
        [wuliaobianma]: item.code,
        [wuliaomingcheng]: item.name,
        [jibenfenlei]: item.typeText,
        [chanpinfenlei]: item.value,
        [morendanwei]: item.defaultUnit,
        [guige]: item.spec,
        [dangqianliaohao]: item.no,
        [jiliangdanwei]: item.unit,
        [baozhuangfangshi]: item.pack,
        [maozhong]: item.grossWeight,
        [jingzhong]: item.netWeight,
        [jianyanfenlei]: item.checkoutType,
        [paichanyanse]: item.planColor,
        [yanse]: item.color,
        [sehao]: item.colorNum,
        [caizhi]: item.ingredient,
        [tuhao]: item.drawingNo,
        [miaoshu]: item.describe,
        [erpwuliaobianma]: item.erpMaterialCode,
        [shifouqiyong]: item.enabledText
      }));
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, this.$t('yanzhengjieguo'));
      XLSX.writeFile(wb, this.$t('yanzhengjieguo') + '.xlsx');
      this.exportLoading = false;
    },
    countTableHeight() {
      this.tableHeight = 0;
      this.$nextTick(() => {
        if (this.tableData.length > 0) {
          this.tableHeight = this.$refs.table.offsetHeight - 10;
        } else {
          this.tableHeight = 110;
        }
      });
    },
    //深拷贝
    deepClone(data) {
      const type = this.judgeType(data);
      let obj;
      if (type === 'array') {
        obj = [];
      } else if (type === 'object') {
        obj = {};
      } else {
        // 不再具有下一层次
        return data;
      }
      if (type === 'array') {
        // eslint-disable-next-line
        for (let i = 0, len = data.length; i < len; i++) {
          obj.push(this.deepClone(data[i]));
        }
      } else if (type === 'object') {
        // 对原型上的方法也拷贝了....
        // eslint-disable-next-line
        for (const key in data) {
          obj[key] = this.deepClone(data[key]);
        }
      }
      return obj;
    },
    judgeType(obj) {
      // tostring会返回对应不同的标签的构造函数
      const toString = Object.prototype.toString;
      const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
      };
      if (obj instanceof Element) {
        return 'element';
      }
      return map[toString.call(obj)];
    },
    // 導出校驗後的excel文件
    exportReportExcel() {


    },
    // 日期转换

    exportModel() {
      window.open((process.env.NODE_ENV === 'development' ? global.URL_DEV_API_BASE_DOMAIN : process.env.VUE_APP_SERVER === 'preview' ? global.URL_PRE_API_BASE_DOMAIN : global.URL_PROD_API_BASE_DOMAIN) + '/web/customer/files/viewFileByFileId/wuliaoxinxidaorumuban');
    },
    importData() {
      const data = this.deepClone([...this.tableData]);
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      this.loading = true;
      for (let i = 0; i < data.length; i++) {
        if (data[i]['typeText'] == this.$t('RawMaterials')) {
          data[i]['type'] = '1';
        } else if (data[i]['typeText'] == this.$t('SemiFinishedProducts')) {
          data[i]['type'] = '2';
        } else if (data[i]['typeText'] == this.$t('FinishedProduct')) {
          data[i]['type'] = '3';
        } else if (data[i]['typeText'] == this.$t('SpareParts')) {
          data[i]['type'] = '4';
        } else {
          this.loading = false;
          return this.$message.error(this.$t('wuliaojibenfenleiyouwu'));
        }
        if (Number.isNaN(data[i]['type'])) {
          data[i]['type'] = '';
        }
        //是否启用转布尔型
        if (data[i]['enabledText'] == this.$t('shi')) {
          data[i]['enabled'] = true;
        } else if (data[i]['enabledText'] == this.$t('fou')) {
          data[i]['enabled'] = false;
        }
        delete data[i]['excel'];
      }
      if (this.listLength == null || this.listLength.length == 0) {
        return this.http
          .post('/web/basic/material/batchImport?onlyValidate=false', data)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.show = false;
            // 刷新主页面列表(参数要与被调用得页面$on()中名称对应)
            this.utils.event_hub.$emit('BASE_MATTER_REFRESH');
          })
          .catch(error => {
            this.loading = false;
            this.utils.errorMessage(error);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
      }
    },
    /**
     * 数据解析
     * @param header
     * @param results
     * @param name
     */
    generateData({ header, results, name }) {
      if (results.length > 10000) {
        this.$message.error(this.$t('zuidadaorushujvtiaoshu') + ': ' + 10000);
        return false;
      }
      this.loading = true;
      const data = [];
      if (results.length > 0) {
        for (let i = 0; i < results.length; i++) {
          const item = {
            excel: name
          };
          for (let j = 0; j < this.tableColumn.length; j++) {
            if (results[i][this.tableColumn[j]['label']] !== undefined) {
              this.$set(item, this.tableColumn[j]['prop'], results[i][this.tableColumn[j]['label']]);
            }
          }
          // 类型字段转数值类型
          if (Number.isNaN(item['type'])) {
            item['type'] = '';
          }
          const grossWeight = item['grossWeight'];
          if (grossWeight !== undefined) {
            item['grossWeight'] = parseFloat(grossWeight);
          }
          const netWeight = item['netWeight'];
          if (netWeight !== undefined) {
            item['netWeight'] = parseFloat(netWeight);
          }
          data.push(item);
        }
      }
      this.tableData = this.tableData.concat(data);
      this.excel.push(name);

      this.countTableHeight();
      this.loading = false;
    },
    /**
     * 显示上传弹框
     */
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    /**
     * 点击上传
     * @param e
     * @returns {Promise<void>}
     */
    async handleClick(e) {
      this.isLoading = true;
      const files = e.target.files;
      // console.log(e)
      for (let i = 0; i < files.length; i++) {
        this.beforeUpload(files[i]);
      }

      document.getElementById('matterFileInput').value = '';
      setTimeout(() => {
        this.loading = true;
        let data = [...this.tableData];
        for (let i = 0; i < data.length; i++) {
          if (data[i]['typeText'] == this.$t('RawMaterials')) {
            data[i]['type'] = '1';
          } else if (data[i]['typeText'] == this.$t('SemiFinishedProducts')) {
            data[i]['type'] = '2';
          } else if (data[i]['typeText'] == this.$t('FinishedProduct')) {
            data[i]['type'] = '3';
          } else if (data[i]['typeText'] == this.$t('SpareParts')) {
            data[i]['type'] = '4';
          }
          if (Number.isNaN(data[i]['type'])) {
            data[i]['type'] = '';
          }
          //是否启用转布尔型
          if (data[i]['enabledText'] == this.$t('shi')) {
            data[i]['enabled'] = true;
          } else if (data[i]['enabledText'] == this.$t('fou')) {
            data[i]['enabled'] = false;
          }
          delete data[i]['excel'];
        }
        this.http
          .post('/web/basic/material/batchImport?onlyValidate=true', data)
          .then(response => {
            if (response.msg === 'success') {
              this.isLoading = false;
            }
            this.listLength = response.data.validateItems;
            if (response.data.validateItems && response.data.validateItems.length > 0) {
              const list = response.data.validateItems;
              for (let i = 0; i < list.length; i++) {
                this.$set(this.tableData[Number(list[i]['index'])], 'result', list[i]['items'].join(','));
              }
            }
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            this.utils.errorMessage(this.$t(error));
          });
      }, 800);
      this.loading = false;
    },
    /**
     * 上传前
     * @param rawFile
     * @returns {boolean}
     */
    beforeUpload(rawFile) {
      if (this.excel.length < 2) {
        //this.$refs['excel-upload-input'].value = null
      }
      if (!this.isExcel(rawFile)) {
        this.$message.error(this.$t('zhizhichi') + '.xlxs,xls,csv' + this.$t('geshiwenjian'));
        return false;
      }
      if (this.excel.length > 2) {
        this.$message.error(this.$t('zuidazhichi') + '3' + this.$t('geexcelwenjian'));
        return false;
      }
      if (this.excel.includes(rawFile.name)) {
        this.$message.error(rawFile.name + this.$t('wenjianyicunzai'));
        return false;
      }
      this.readerData(rawFile);
    },

    /**
     * 解析excel
     * @param rawFile
     */
    readerData(rawFile) {
      this.loading = true;
      const reader = new FileReader();
      reader.onload = e => {
        const name = rawFile.name;
        const data = e.target.result;
        const workbook = XLSX.read(data, {
          type: 'array'
        });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const header = this.getHeaderRow(worksheet);
        const results = XLSX.utils.sheet_to_json(worksheet);
        this.generateData({
          header,
          results,
          name
        });
        this.loading = false;
      };
      reader.readAsArrayBuffer(rawFile);
    },
    /**
     * 获取excel头部
     * @param sheet
     * @returns {[]}
     */
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet['!ref']);
      let C;
      const R = range.s.r;
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell =
          sheet[
          XLSX.utils.encode_cell({
            c: C,
            r: R
          })
          ];
        let hdr = 'UNKNOWN ' + C;
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * 判断是否为excel文件
     * @param file
     * @returns {boolean}
     */
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
    /**
     * 页码
     * @param val
     */
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
    },
    /**
     * 分页
     * @param val
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
    },
    /**
     * 刪除excel
     * @param name
     */
    deleteExcel(name) {
      this.excel = this.excel.filter(item => {
        return item !== name;
      });
      this.tableData = this.tableData.filter(item => {
        return item.excel !== name;
      });
      // console.log("excel:", this.excel)
      // console.log('tableData:', this.tableData)
      // console.log('tableColumn', this.tableColumn)
    }
  }
};
</script>

<style scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}

.drop {
  border: 2px dashed #bbb;
  width: 600px;
  height: 160px;
  line-height: 160px;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
</style>
